module.exports = __webpack_public_path__ + "img/elvenett.5bc23794.jpg";